module.exports = __webpack_public_path__ + "img/img_web04_zshu4.fbb17388.jpg";